// extracted by css-extract-rspack-plugin
export default {"widthFor_cep-courses_table_name":"fIM_fVqfu_Qjw68B"};